// South Korea products: imported Thrillophilia trips only (no generic package set).
import { japanAndSouthKoreaDiscoveryProduct } from './japanAndSouthKoreaDiscoveryData';
import { koreaAndJapanShortGroupTourProduct } from './koreaAndJapanShortGroupTourData';
import { koreaJapanHiroshimaGetawayProduct } from './koreaJapanHiroshimaGetawayData';

export const southKoreaProducts = [koreaAndJapanShortGroupTourProduct, koreaJapanHiroshimaGetawayProduct, japanAndSouthKoreaDiscoveryProduct];
